import Swiper from 'swiper';

$(document).ready(function () {


    $('.image-slider').slick({
        infinite: true,
        dots: true,
        nextArrow:
            '<div class="slider-arrow-container next">' +
            '<div class="slider-arrow"></div>' +
            '<svg class="arrow-right" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="13px"><path fill-rule="evenodd" fill="rgb(255, 255, 255)" d="M16.491,0.861 C16.334,1.000 16.261,1.169 16.271,1.369 C16.281,1.567 16.354,1.736 16.491,1.875 L20.001,5.307 L0.711,5.307 C0.516,5.307 0.350,5.377 0.214,5.516 C0.077,5.655 0.009,5.824 0.009,6.024 L0.009,6.978 C0.009,7.177 0.077,7.346 0.214,7.486 C0.350,7.625 0.516,7.695 0.711,7.695 L20.001,7.695 L16.491,11.126 C16.354,11.266 16.281,11.434 16.271,11.633 C16.261,11.832 16.334,12.001 16.491,12.141 L17.134,12.798 C17.271,12.936 17.436,13.007 17.631,13.007 C17.827,13.007 17.992,12.936 18.129,12.798 L23.804,7.009 C23.941,6.868 24.009,6.700 24.009,6.500 C24.009,6.301 23.941,6.133 23.804,5.994 L18.129,0.204 C17.992,0.065 17.827,-0.005 17.631,-0.005 C17.436,-0.005 17.271,0.065 17.134,0.204 L16.491,0.861 Z"></path></svg>' +
            '</div>',
        prevArrow:
            '<div class="slider-arrow-container prev">' +
            '<div class="slider-arrow"></div>' +
            '<svg class="arrow-left" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="13px"><path fill-rule="evenodd" fill="rgb(255, 255, 255)" d="M16.491,0.861 C16.334,1.000 16.261,1.169 16.271,1.369 C16.281,1.567 16.354,1.736 16.491,1.875 L20.001,5.307 L0.711,5.307 C0.516,5.307 0.350,5.377 0.214,5.516 C0.077,5.655 0.009,5.824 0.009,6.024 L0.009,6.978 C0.009,7.177 0.077,7.346 0.214,7.486 C0.350,7.625 0.516,7.695 0.711,7.695 L20.001,7.695 L16.491,11.126 C16.354,11.266 16.281,11.434 16.271,11.633 C16.261,11.832 16.334,12.001 16.491,12.141 L17.134,12.798 C17.271,12.936 17.436,13.007 17.631,13.007 C17.827,13.007 17.992,12.936 18.129,12.798 L23.804,7.009 C23.941,6.868 24.009,6.700 24.009,6.500 C24.009,6.301 23.941,6.133 23.804,5.994 L18.129,0.204 C17.992,0.065 17.827,-0.005 17.631,-0.005 C17.436,-0.005 17.271,0.065 17.134,0.204 L16.491,0.861 Z"></path></svg>' +
            '</div>',
    });


    $('.image-title-teaser-slider').slick({
        infinite: true,
        appendArrows: '.arrow-container',
        nextArrow: '<svg class="arrow-right" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="13px"><path fill-rule="evenodd" fill="rgb(255, 0, 0)" d="M16.491,0.861 C16.334,1.000 16.261,1.169 16.271,1.369 C16.281,1.567 16.354,1.736 16.491,1.875 L20.001,5.307 L0.711,5.307 C0.516,5.307 0.350,5.377 0.214,5.516 C0.077,5.655 0.009,5.824 0.009,6.024 L0.009,6.978 C0.009,7.177 0.077,7.346 0.214,7.486 C0.350,7.625 0.516,7.695 0.711,7.695 L20.001,7.695 L16.491,11.126 C16.354,11.266 16.281,11.434 16.271,11.633 C16.261,11.832 16.334,12.001 16.491,12.141 L17.134,12.798 C17.271,12.936 17.436,13.007 17.631,13.007 C17.827,13.007 17.992,12.936 18.129,12.798 L23.804,7.009 C23.941,6.868 24.009,6.700 24.009,6.500 C24.009,6.301 23.941,6.133 23.804,5.994 L18.129,0.204 C17.992,0.065 17.827,-0.005 17.631,-0.005 C17.436,-0.005 17.271,0.065 17.134,0.204 L16.491,0.861 Z"></path></svg>',
        prevArrow: '<svg class="arrow-left" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="13px"><path fill-rule="evenodd" fill="rgb(255, 0, 0)" d="M16.491,0.861 C16.334,1.000 16.261,1.169 16.271,1.369 C16.281,1.567 16.354,1.736 16.491,1.875 L20.001,5.307 L0.711,5.307 C0.516,5.307 0.350,5.377 0.214,5.516 C0.077,5.655 0.009,5.824 0.009,6.024 L0.009,6.978 C0.009,7.177 0.077,7.346 0.214,7.486 C0.350,7.625 0.516,7.695 0.711,7.695 L20.001,7.695 L16.491,11.126 C16.354,11.266 16.281,11.434 16.271,11.633 C16.261,11.832 16.334,12.001 16.491,12.141 L17.134,12.798 C17.271,12.936 17.436,13.007 17.631,13.007 C17.827,13.007 17.992,12.936 18.129,12.798 L23.804,7.009 C23.941,6.868 24.009,6.700 24.009,6.500 C24.009,6.301 23.941,6.133 23.804,5.994 L18.129,0.204 C17.992,0.065 17.827,-0.005 17.631,-0.005 C17.436,-0.005 17.271,0.065 17.134,0.204 L16.491,0.861 Z"></path></svg>',
    });

    $('.image-title-teaser-slider .arrow-left').click(function () {
        $('.image-title-teaser-slider').slick('slickPrev');
    })
    $('.image-title-teaser-slider .arrow-right').click(function () {
        $('.image-title-teaser-slider').slick('slickNext');
    })

    if(detectmob()) {
        var swiper = new Swiper('.wheel-slider', {
            // slidesPerView: 3,
            slidesPerView: 'auto',
            centeredSlides: true,
            effect: 'flip',
            slideToClickedSlide: true,
            speed: 800,
            grabCursor: true,
            flipEffect: {
                rotate: 30,
                slideShadows: false,
            },
            simulateTouch: true,
            loop: true
        });
    }else{
        var swiper = new Swiper('.wheel-slider', {
            // slidesPerView: 3,
            slidesPerView: 'auto',
            centeredSlides: true,
            effect: 'coverflow',
            slideToClickedSlide: true,
            speed: 800,
            grabCursor: true,
            coverflowEffect: {
                rotate: 0,
                stretch: 50,
                depth: 100,
                modifier: 3,
                slideShadows: false
            },
            simulateTouch: true,
            loop: true
        });
    }

    if (swiper.slides != undefined) {
        var slidesPerView = swiper.slides.length;
        console.log(slidesPerView);
        swiper.slideTo(Math.floor(slidesPerView / 2));

    }


});

function detectmob() {
    if( navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/Windows Phone/i)
    ){
        return true;
    }
    else {
        return false;
    }
}